import { Col, Container, Row } from 'react-bootstrap'
import childrensvg from '../assets/images/children.svg'
import childrenCss from './cssModule/children.module.css'

const Children = ({ handleAdd }) => {
  return (
    <Container>
      <Row>
        <Col md={4} className='d-flex flex-column justify-content-between'>
          <div className={childrenCss.addButton} onClick={handleAdd}>
            +
          </div>
        </Col>
        <Col md={8} className={childrenCss.imageContainer}>
          <figure>
            <img src={childrensvg} alt='' />
          </figure>
        </Col>
      </Row>
    </Container>
  )
}

export default Children
